(ns nosco.ui.dropzone
  (:require
   ["react" :as React]
   ["react-dropzone" :refer [useDropzone]]
   [hx.react :refer [defnc]]
   [nosco.i18n.translate :as t]
   [nosco.icons2 :as icons2]
   [nosco.ui.buttons]
   [nosco.ui.buttons2 :as buttons2]
   [nosco.ui.text :as text]))

;; implementing this with plain react because hx
;; doesn't like a js map as props; perhaps though
;; we should add this to the hx parsing mechanism?
(defn DropzoneImpl [^js props]
  (let [dropzone (.-dropzone props)
        children (.-children props)]
    (React/createElement "div" (.getRootProps dropzone #js {:className (.-class props) :style (.-style props)})
                         (React/createElement "input" (.getInputProps dropzone))
                         children)))

(defn use-dropzone
  "Convenience wrapper over useDropzone that deals with common arguments.
  For more options either extend this or use useDropzone directly."
  [{:keys [on-drop accept max-files no-click disabled]}]
  (let [props (cond-> {:onDrop on-drop}
                accept (assoc :accept accept)
                disabled (assoc :disabled disabled)
                no-click (assoc :noClick no-click)
                max-files (assoc :maxFiles max-files))]
    (useDropzone (clj->js props))))

(defn drag-active? [^js dropzone]
  (.-isDragActive dropzone))

(defnc Dropzone [{:keys [on-drop accept max-files button-label text active width height style]}]
  (let [dropzone (use-dropzone {:on-drop on-drop
                                :accept accept
                                :max-files max-files})
        active? (or active (drag-active? dropzone))
        button-label (or button-label
                         (t/tp ["Add file"
                                "Add files"]
                               (or max-files 1)))
        text (or text
                 (t/tp ["or drop file to upload"
                        "or drop files to upload"]
                       (or max-files 1)))]
    [DropzoneImpl {:dropzone dropzone
                   :class (if active?
                            "nosco-dropzone nosco-dropzone--active"
                            "nosco-dropzone")
                   :style (or style {:height (or height 230) :max-width (or width 544)})}
     [icons2/Icon {:icon icons2/UploadCloud-small
                   :class "nosco-dropzone__icon"}]
     [buttons2/Button {:variant buttons2/NewSubtle
                       :size buttons2/SizeSmall
                       :class "nosco-dropzone__button"
                       :label button-label}]
     [text/Text {:variant text/Body-Sm-Regular
                 :class "nosco-dropzone__label"}
      text]]))

(defnc UploadedFile
  "Figma Dropzone/UploadProgessbar: the file that was picked, with a remove button.

  Props:
  - :name - the file name
  - :size - a formatted file size, e.g. \"68 KB\"
  - :error - optional, shown instead of the size
  - :on-retry - optional, shows a retry button
  - :on-remove - called when the remove button is clicked
  - :disabled - optional, disables the retry and remove buttons"
  [{:keys [name size error on-retry on-remove disabled]}]
  [:div {:class "nosco-uploaded-file"}
   [:div {:class "nosco-uploaded-file__icon"}
    [icons2/Icon {:icon icons2/File-large}]]
   [:div {:class "nosco-uploaded-file__text"}
    [text/Text {:variant text/Body-Md-Bold
                :el :div
                :truncate true}
     name]
    [text/Text {:variant text/Body-Sm-Regular
                :el :div
                :class (if error "nosco-uploaded-file__error" "nosco-uploaded-file__size")}
     (or error size)]]
   (when on-retry
     [buttons2/Button {:variant buttons2/NewIcon
                       :icon icons2/Refresh-large
                       :aria-label (t/t "Retry")
                       :disabled disabled
                       :on-click on-retry}])
   [buttons2/Button {:variant buttons2/NewIcon
                     :icon icons2/Close-large
                     :aria-label (t/t "Remove file")
                     :disabled disabled
                     :on-click on-remove}]])
